// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  orgId: __t.string().name("org_id"),
  orgName: __t.string().name("org_name"),
  kind: __t.string(),
  targetId: __t.string().name("target_id"),
  name: __t.string(),
  deletedAt: __t.timestamp().name("deleted_at"),
  deletedByUserId: __t.string().name("deleted_by_user_id"),
  deletedByName: __t.string().name("deleted_by_name"),
  purgeAt: __t.timestamp().name("purge_at"),
  bytes: __t.f64(),
  rowCount: __t.u32().name("row_count"),
  summary: __t.string(),
});
